import { Component, EventEmitter, Input, Output } from '@angular/core'
import { InstallationItem } from '../../../models/installation-item.model'

@Component({
    selector: 'app-customer-relations-summary',
    templateUrl: './customer-relations-summary.component.html',
    styleUrls: ['./customer-relations-summary.component.scss'],
    standalone: false,
})
export class CustomerRelationsSummaryComponent {
    @Input() public selectedItem: InstallationItem = null
    @Input() public canToggle = false
    @Input() public isExpanded = false

    @Output() public toggleExpand = new EventEmitter<void>()

    public onToggle(): void {
        if (!this.canToggle) {
            return
        }

        this.toggleExpand.emit()
    }
}
